<template>
  <div>
    <div class="flex mb-3 font-size-subtitle-2">
      <div class="col">
        不套用門市
      </div>
      <div class="w-md"></div>
      <div class="col">
        套用門市
      </div>
    </div>
    <v-multiselect-listbox
      v-model="setting.choose"
      class="col-xs-12"
      :options="setting.options"
      :reduce-display-property="(option) => option.label"
      :reduce-value-property="(option) => option.value"
      :search-input-class="setting.class"
      search-options-placeholder="搜尋..."
      selected-options-placeholder="搜尋..."
    />
    <div class="clear-both" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'nd-trade-apply-store-multi-select-listbox',
  props: {
    brandId: {
      type: Number,
      default: 0
    },
    getDataH: {
      type: Function
    },
    status: {
      type: Array,
      default: () => {
        /**
         * 0：尚未營業
         * 1：籌備中
         * 2：營業中(上架)
         * 3：休息中
         * 9：已歇業
         */
        return [2, 3]
      }
    },
    tradeType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      setting: {
        class: 'nd-trade-apply-store-multi-select-input',
        options: [],
        choose: []
      },
      stores: [],
      storesTradeApplied: []
    }
  },
  computed: {
    ...mapGetters(['getRoleType'])
  },
  watch: {
    brandId: {
      immediate: true,
      handler () {
        this.getInfo()
      }
    },
    'setting.choose' (val) {
      this.$emit('update:choose', val)
    }
  },
  methods: {
    formatData () {
      console.log({
        component: this.$options.name,
        function: 'formatData',
        payload: {},
        time: moment().format('HH:mm:ss')
      })

      for (let i = 0; i < this.stores.length; i++) {
        if (this.storesTradeApplied.indexOf(this.stores[i].store_id) === -1) {
          let temp = {
            label: this.stores[i].name,
            value: this.stores[i].store_id
          }
          this.setting.options.push(temp)
        }
      }
    },
    async getInfo () {
      this.setting.choose = []
      await this.getStores()
      await this.getStoresTrade()
      this.formatData()
    },
    getStores () {
      console.log({
        component: this.$options.name,
        function: 'getStores',
        payload: {},
        time: moment().format('HH:mm:ss')
      })

      return new Promise((resolve, reject) => {
        this.stores = []
        this.setting.options = []

        if (!this.brandId) {
          resolve()
          return
        }

        let url = `/brand/${this.brandId}/storeListBrief`
        let temp = []

        // handler query
        temp.push(`status=${this.status.join(',')}`)
        if (temp.length && url.indexOf('?') === -1) url = url + '?'
        url = url + temp.join('&')
        // End handler query

        this.getDataH('get', url, null, (res) => {
          if (res.data.status === 200) {
            this.stores = res.data.list
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    /** 取得品牌下的icashpay門市列表 */
    getStoresTrade () {
      console.log({
        component: this.$options.name,
        function: 'getStoresTrade',
        payload: {},
        time: moment().format('HH:mm:ss')
      })

      return new Promise((resolve, reject) => {
        if (!this.brandId) {
          resolve()
          return
        }

        const url = `/tradeTypeBiz/storelist/${this.brandId}?trade_type=${this.tradeType}`
        this.getDataH('get', url, null, (res) => {
          if (res.data.status === 200) {
            this.storesTradeApplied = res.data.exist_store_list
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    updataChoose () {
      this.setting.choose = []
      this.storeClass.store_list.forEach((i) => {
        const storeIndex = this.stores.findIndex((store) => {
          return i.id === store.store_id
        })
        if (storeIndex !== -1) {
          this.setting.choose.push(i.id)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.clear-both {
  clear: both;
}
.col {
  flex-grow: 1;
}
.font-size-subtitle-2 {
  font-size: 14px;
}
.w-md {
  width: 20px;
}
</style>

<style lang="scss">
.nd-trade-apply-store-multi-select-input {
  margin-bottom: 0px !important;
  padding: 5px 10px !important;
}
</style>



// WEBPACK FOOTER //
// nd-trade-apply-store-multi-select-listbox.vue?4b572a08